const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC_SEGMENT = /^\d+$/;
const EMAIL_SEGMENT = /@|%40/i;
const FILENAME_SEGMENT = /\.[a-z0-9]{1,5}$/i;
const PARAM_PARENTS = new Set(["users", "attachments"]);

function normalizeSegment(segment: string, previous: string | undefined): string {
  if (segment === "") {
    return segment;
  }
  if (UUID_SEGMENT.test(segment) || NUMERIC_SEGMENT.test(segment)) {
    return ":id";
  }
  if (
    (previous !== undefined && PARAM_PARENTS.has(previous)) ||
    EMAIL_SEGMENT.test(segment) ||
    FILENAME_SEGMENT.test(segment)
  ) {
    return ":param";
  }
  return segment;
}

export const normalizeRequestPath = (path: string): string => {
  const segments = (path.split(/[?#]/)[0] ?? "").split("/");
  return segments.map((segment, index) => normalizeSegment(segment, segments[index - 1])).join("/");
};
